/* global Swiper */
import Rails from 'rails-ujs';

window.addEventListener('load', () => {
  if (typeof Swiper === 'undefined') return;

  // ======== 通常のスライダー初期化 ========
  const swiperContainer = Rails.$('.swiper-slider');
  const swiperSpecialCampaign = Rails.$('.swiper-slider-special-campaign');
  const sliderImageCount = Rails.$('.slider_image').length;
  const sliderThumbsCount = Rails.$('.swiper-thumbs').length;

  if (swiperSpecialCampaign.length !== 0) {
    // eslint-disable-next-line no-unused-vars
    const slider = new Swiper('.swiper-slider-special-campaign', {
      slidesPerView: 1,
      centeredSlides: true,
      loopedSlides: sliderImageCount,
      navigation: {
        nextEl: null,
        prevEl: null
      },
      pagination: {
        el: null
      }
    });
  }

  if (swiperContainer.length !== 0) {
    // eslint-disable-next-line no-unused-vars
    const slider = new Swiper('.swiper-slider', {
      slidesPerView: 1,
      centeredSlides: true,
      loopedSlides: sliderImageCount,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    if (sliderThumbsCount !== 0) {
      const thumbs = new Swiper('.swiper-thumbs', {
        slidesPerView: 'auto',
        spaceBetween: 15,
        centeredSlides: true,
        slideToClickedSlide: true,
      });

      slider.controller.control = thumbs;
      thumbs.controller.control = slider;
    }
  }

  // ======== lp11/watch 専用スライダー（steps / qa）========
  const sliders = [
    {
      selector: '.js-stepper-carousel',
      nextEl: '.c-stepper-carousel__button--next',
      prevEl: '.c-stepper-carousel__button--prev',
      paginationEl: '.c-stepper-carousel__pagination',
      imageClass: '.c-stepper-carousel__image'
    },
    {
      selector: '.p-qa-carousel__slider',
      nextEl: '.p-qa-carousel__next',
      prevEl: '.p-qa-carousel__prev',
      paginationEl: '.p-qa-carousel__pagination',
      imageClass: '.p-qa-carousel__image'
    }
  ];

  sliders.forEach(({ selector, nextEl, prevEl, paginationEl, imageClass }) => {
    const container = document.querySelector(selector);
    if (!container) return;

    const imageCount = container.querySelectorAll(imageClass).length;
    
    new Swiper(selector, {
      slidesPerView: 1,
      centeredSlides: true,
      loop: true,
      speed: 300,
      loopedSlides: imageCount,
      loopAdditionalSlides: 2,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl,
        prevEl,
      },
      pagination: {
        el: paginationEl,
        clickable: true,
      },
      breakpoints: {
        769: {
          slidesPerView: 1,
          centeredSlides: true,
        }
      }
    });
  });
});
